import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from "../../axios/axiosconf";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";
import DataTable from "react-data-table-component";

function ParametrosRDA() {
    const history = useHistory();
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(null);
    const [esAdminPersonal, setEsAdminPersonal] = useState(false);
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);
    const [terminoBusqueda, setTerminoBusqueda] = useState("");
    const [loadingTable, setLoadingTable] = useState(true);

    const cargarLista = () => {
        setLoadingTable(true);
        axios
            .get("/interop-user-configs", { params: { termino: terminoBusqueda } })
            .then((response) => {
                setItems(response.data || []);
            })
            .catch((error) => {
                console.error("Error al cargar parámetros RDA:", error);
                setItems([]);
                const msg =
                    error.response?.data?.message ||
                    (error.response?.status === 500
                        ? "Error del servidor. Verifique que exista la tabla interop_user_configs (migración o script SQL en Kiro/sql)."
                        : "No se pudo cargar la lista.");
                if (typeof window !== "undefined" && window.alert) {
                    window.alert(msg);
                }
            })
            .finally(() => setLoadingTable(false));
    };

    useEffect(() => {
        if (!localStorage.getItem("userdata")) {
            setHasPermission(false);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem("userdata"));
        let permisosList = [];
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            permisosList = userdata.permissions.map((p) => p.slug);
        } else if (userdata.up) {
            permisosList = userdata.up;
        }

        const ok =
            permisosList.includes("administrarPersonalProveedores") ||
            permisosList.includes("gestionPersonal");

        if (!ok) {
            setHasPermission(false);
            return;
        }

        setHasPermission(true);

        axios
            .get("/get-client?uid=" + userdata.user_id)
            .then((response) => {
                if (response.status === 200) {
                    setClient(response.data);
                }
                setLoggedIn(true);
            })
            .catch(() => setLoggedIn(true));
    }, []);

    useEffect(() => {
        if (hasPermission === true) {
            cargarLista();
        }
    }, [hasPermission, terminoBusqueda]);

    const cols = [
        {
            name: "Profesional",
            selector: (row) => `${row.name || ""} ${row.lastname || ""}`.trim(),
            sortable: true,
            grow: 2,
        },
        {
            name: "Documento",
            selector: (row) =>
                [row.tipo_documento, row.numero_documento].filter(Boolean).join(" ") || "—",
            sortable: true,
        },
        {
            name: "REPS",
            selector: (row) => row.reps_code || "—",
            sortable: true,
            width: "130px",
        },
        {
            name: "Credenciales",
            cell: (row) => (
                <span className={`badge badge-${row.rda_configured ? "success" : "secondary"}`}>
                    {row.rda_configured ? "Configurado" : "Pendiente"}
                </span>
            ),
            width: "120px",
        },
        {
            name: "Cert. PEM",
            cell: (row) => (
                <span className={`badge badge-${row.has_cert ? "info" : "light"}`}>
                    {row.has_cert ? "Cargado" : "Sin PEM"}
                </span>
            ),
            width: "110px",
        },
        {
            name: "Acción",
            cell: (row) => (
                <Link
                    to={`/parametros-rda-usuario?id=${row.id}`}
                    className="btn btn-info btn-sm"
                >
                    <i className="fas fa-cog mr-1"></i>
                    Configurar
                </Link>
            ),
            width: "140px",
        },
    ];

    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (hasPermission !== true || !loggedIn) {
        return <Loading />;
    }

    return (
        <div className="wrapper hold-transition" style={{ fontSize: "13px" }}>
            <Header client={client} />
            <Aside client={client} activelink="settings" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <ol className="breadcrumb float-sm-left mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/home">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/settings">Configuración</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/personal-proveedores">Personal y proveedores</Link>
                                    </li>
                                    <li className="breadcrumb-item active">Parámetros RDA</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2 align-items-end">
                            <div className="col-md-8">
                                <div className="dash-wrap">
                                    <h1 className="dash-title">Parámetros RDA</h1>
                                    <p className="dash-subtitle mb-0">
                                        Administración de credenciales por profesional. Cada usuario configura solo las suyas.
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-4 mt-2 mt-md-0 text-md-right">
                                <Link
                                    to="/personal-proveedores"
                                    className="btn btn-outline-secondary btn-sm mr-2"
                                    style={{ borderRadius: "10px", fontWeight: 600 }}
                                >
                                    <i className="fas fa-arrow-left mr-1"></i> Volver
                                </Link>
                                {esAdminPersonal && (
                                    <Link
                                        to="/configuracion-rda"
                                        className="btn btn-outline-info btn-sm"
                                        style={{ borderRadius: "10px", fontWeight: 600 }}
                                    >
                                        Config. general clínica (legacy)
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <div className="dash-card">
                            <div className="dash-card-header d-flex flex-wrap align-items-center justify-content-between">
                                <h2 className="dash-card-title mb-2 mb-md-0">
                                    <span className="title-icon">
                                        <i className="fas fa-exchange-alt"></i>
                                    </span>
                                    Usuarios del cliente
                                </h2>
                                <div className="form-group mb-0" style={{ minWidth: "220px" }}>
                                    <input
                                        type="search"
                                        className="form-control form-control-sm"
                                        placeholder="Buscar por nombre o documento…"
                                        value={terminoBusqueda}
                                        onChange={(e) => setTerminoBusqueda(e.target.value)}
                                        style={{ borderRadius: "10px" }}
                                    />
                                </div>
                            </div>
                            <div className="dash-card-body">
                                <DataTable
                                    columns={cols}
                                    data={items}
                                    pagination
                                    paginationPerPage={15}
                                    highlightOnHover
                                    dense
                                    progressPending={loadingTable}
                                    noDataComponent="No hay usuarios para mostrar."
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default ParametrosRDA;
